var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-container"},[_c('XTopMenu',{staticClass:"top-menu",attrs:{"menus":_vm.filteredTopRoutes}}),_c('div',{staticClass:"flex"},[_c('XLeftMenu',{staticClass:"XLeftMenu"}),_c('router-view',{staticClass:"flex1 p10"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }